













import config from 'config'
import { Vue, Component } from 'vue-property-decorator'
import { State, Action } from 'vuex-class'

import Contentloader from '@/components/Contentloader.vue'
import ChooseCountry from '@/components/ChooseCountry.vue'
import { ECallbackType } from '../services/CallbackService'

const MinimalLayout = () => import(/* webpackChunkName: "minimal-layout" */ '../layouts/Minimal.vue')
const NetatmoLayout = () => import(/* webpackChunkName: "netatmo-layout" */ '../layouts/Netatmo.vue')

const LegalsContent = () => import(/* webpackChunkName: "legals-content" */ '@/components/LegalsContent.vue')
const LegalsContentTabs = () => import(/* webpackChunkName: "legals-content" */ '@/components/LegalsContentTabs.vue')

@Component({
  components: {
    MinimalLayout,
    NetatmoLayout,
    Contentloader,
    LegalsContent,
    LegalsContentTabs,
    ChooseCountry
  }
})
export default class Home extends Vue {
  @State(state => state.CONTENT.needCountrySelection) needCountrySelection!: boolean
  @Action('CONTENT/loadConsent') loadConsent!: () => void

  private useTabs = config.content.useTabs || false
  private loading = false

  get layout () {
    return `${(config.content.layout || 'minimal')}-layout`
  }

  async mounted () {
    this.loading = true
    await this.loadConsent()
    this.loading = false
    this.$nextTick(() => {
      Vue.prototype.$callback.call(ECallbackType.onPageLoaded)
    })
  }
}
